<template>
    <div id="searchable-health-post" class="container">
        <div class="row justify-content-center">
            <div class="col-md-9 mb-3"></div>
            <div class="col-md-3 text-right back-btn__mobile">
                <a id='back-button' class="btn btn-primary btn-sb-red" href="/searchable-health-library" title="Redirect to Library Page">Back to Searchable Health Library</a>
            </div>
        </div>
        <div id="searchable-health-post-html" v-html="html"></div>
    </div>
</template>

<script>
export default {
    name: "SBSearchableHealthLibraryPost",
    props: ['html'],
    data() {
        return {}
    },
    methods: {},
}
</script>

<style scoped>

</style>
